import { Record, SimpleForm, TextInput, email, required } from "react-admin";
import {
  DemoAccountDto,
  DemoAccountListDto,
} from "../../../common/data/service-proxies";
import { RaTenantPicker } from "../../common/form/RaTenantPicker";

interface Props {
  record?: DemoAccountDto & DemoAccountListDto & Record;
  toolbar?: React.ReactElement;
  isEdit?: boolean;
}

export const DemoAccountForm = (props: Props) => {
  const { isEdit, ...rest } = props;

  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...rest}>
      <TextInput
        source="name"
        label="Name"
        validate={[required()]}
        autoComplete="given-name"
      />
      <TextInput
        source="surname"
        label="Surname"
        validate={[required()]}
        autoComplete="family-name"
      />
      <TextInput
        source="email"
        label="Login e-mail"
        validate={[required(), email()]}
        disabled={isEdit}
      />
      {!isEdit ? (
        <TextInput source="password" label="Password" validate={[required()]} />
      ) : null}
      <RaTenantPicker label="Customer to use" source="tenantId" />
    </SimpleForm>
  );
};
